import { render, staticRenderFns } from "./create-fun-game.vue?vue&type=template&id=7aea531c&scoped=true"
import script from "./create-fun-game.vue?vue&type=script&lang=js"
export * from "./create-fun-game.vue?vue&type=script&lang=js"
import style0 from "./create-fun-game.vue?vue&type=style&index=0&id=7aea531c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aea531c",
  null
  
)

export default component.exports